import { ProductionTechnologiesRecipes } from "src/app/services/service/DataProviders/ProductionTechnologiesRecipes";
import * as _ from "lodash";
import { take } from "rxjs/internal/operators/take";
import * as moment from "moment";
import { LogisticsInventoryCurrentBalances } from "src/app/services/service/DataProviders/LogisticsInventoryCurrentBalances";

export default class RecipeNode {
  private recepieService: ProductionTechnologiesRecipes;
  private availabilityService: LogisticsInventoryCurrentBalances;

  public measurementUnit;
  private tree;
  public name = '';
  public level = 0; //на кой ред се намира в дървото
  public product = null; // продукта
  public quantity = 0;
  public quantityFromReceipt = 0;
  public po = null;
  public availability = 0;
  public availabilityMeasure = '';
  public availabilityList = [];

  public technologies = []; // списък със всички технологии на продукта
  public defaultTechnology = null; // технология която би се избрала В Е1 по подразбиране
  public defaultTechnologyIngredients = []; // технология която би се избрала В Е1 по подразбиране, нейните съставки
  public defaultTechnologyId = null; //ID технология която би се избрала В Е1 по подразбиране

  public skiped = false;

  constructor(
    level = 0,
    product,
    quantity,
    quantityFromReceipt,
    recepieService: ProductionTechnologiesRecipes,
    tree,
    measurementUnit,
    availabilityService,
  ) {
    this.level = level;
    this.product = product;
    this.recepieService = recepieService;
    this.tree = tree;
    this.quantityFromReceipt = quantityFromReceipt;
    this.setNewQuantity(quantity);
    this.name = this.getProductName();
    this.measurementUnit = measurementUnit;
    this.availabilityService = availabilityService;
  }

  public setNewQuantity(quantity) {
    const totalQuantity = quantity*this.quantityFromReceipt;

    if(this.quantity < 0.00001) {
      this.quantity = _.ceil(totalQuantity, 5);
    }
    else {
      this.quantity = _.round(totalQuantity, 5);
    }
  }

  public async init() {

    const skipPG = _.get(this.product, 'ProductGroup.CustomProperty_PRODUCTIONAPP_SKIP.Value', 'НЕ');
    if(skipPG === 'ДА') {
      // console.log('В продукта има Пх за скипване', this.product);
      await this.getAvailability();
      this.skiped = true;
      return true;
    }

    // Това е специфично за Реалмет
    // проверява дали наличното количество е по голямо от необходимот и ако е така не зарежда рецепта
    const skipProduct = _.get(this.product, 'CustomProperty_CheckAvailableQty.Value', 'Не');
    if(skipProduct === 'Да') {
      console.log('В продукта има Пх за скипване', this.product);
      await this.getAvailability();
      if(this.availability >= this.quantity) {
        console.log('Наличността е по-голяма от необходимото. Продукта се скипва', this.product);
        this.skiped = true;
        return true;
      }

      console.log('Наличността е по-малка от необходимото. Продукта НЕ се скипва', this.product);
    }

    let getRecipesRes = await this.getRecipes();
    if (!getRecipesRes) {
      return false;
    }
    if (this.technologies.length == 0) {
      //няма технология
      // return false;
    }

    // if (this.getProduct()) {
    //   return false;
    // }

    if (!this.getDefaultRecipe()) {
      // return false;
    }
    await this.getAvailability();
    return true;
  }

  private async getRecipes() {
    let call = JSON.parse(JSON.stringify(this.recepieService.stateTemplate));

    call.filter.filters.push({
      field: "ExpiryDate",
      operator: "greaterequalnull",
      value: moment().format('YYYY-MM-DD')+'T00:00:00Z',
    });

    call.filter.filters.push({
      field: "Product",
      operator: "eq",
      value: "'" + this.product["@odata.id"] + "'",
    });

    let res = <any>(
      await this.recepieService.filterRecipeies(call).pipe(take(1)).toPromise()
    );

    this.technologies = res.value;
    return true;
  }

  private async getAvailability() {
    try {
      let call = JSON.parse(JSON.stringify(this.availabilityService.stateTemplate));

      call.filter.filters.push({
        field: "Product",
        operator: "eq",
        value: "'" + this.product["@odata.id"] + "'",
      });

      call.filter.filters.push({
        field: "QuantityBaseValue",
        operator: "ge",
        value: "0.001",
      });

      let res = <any>(
        await this.availabilityService.filter(call).pipe(take(1)).toPromise()
      );
  
      let values = _.get(res, 'value', []);
      values = _.filter(values, (v) => v.QuantityBase.Value > 0);
      this.availability = _.sumBy(values, 'QuantityBase.Value');
      this.availabilityMeasure = _.get(values, '[0].QuantityBase.Unit', '');
      this.availabilityList = _.groupBy(values, (v) => {
        return _.get(v, 'Store.Id', '') + '-'
              + _.get(v, 'Lot.Number', '*') + '-'
              + _.get(v, 'StoreBin.Name.BG', '#');
      });
  
      this.availabilityList = _.map(this.availabilityList, (g) => {
        return {
          total: _.sumBy(g, 'QuantityBase.Value'),
          cost: _.sumBy(g, 'BaseCost.Value'),
          costCurrency: _.sumBy(g, 'BaseCost.Currency'),
          measure: _.get(g, '[0].QuantityBase.Unit', ''),
          list: g,
          storeName: _.get(g, '[0].Store.Name.BG', ''),
          lot: _.get(g, '[0].Lot.Number', ''),
          storeBin: _.get(g, '[0].StoreBin.Name.BG', ''),
        };
      });
    }
    catch(error) {
      console.error('Грешка при взимане на наличност', error);
      this.availabilityList = [];
    }

    return true;
  }

  private getDefaultRecipe() {
    if (this.technologies.length == 0) {
      //продукта не е сложен. Няма технология
      // console.error("produkta ne e slojen");
      return false;
    }

    let valid = []; //тук се попълват всички валидни технологии
    let moreResent = null;

    for (let i = 0; i < this.technologies.length; i++) {
      let tehnologie = this.technologies[i];

      let now = moment();

      if (
        _.isNull(tehnologie.ExpiryDate) ||
        now.isBetween(
          moment(tehnologie.ReleaseDate),
          moment(tehnologie.ExpiryDate)
        )
      ) {
        valid.push(tehnologie);
      }

      if (
        _.isNull(moreResent) ||
        moment(tehnologie.CreationTime).isAfter(moment(moreResent.CreationTime))
      ) {
        moreResent = tehnologie;
      }
    }

    if (valid.length == 0) {
      //няма валидна технология
      console.error("nqma validna tehnologiq");
      return false;
    }

    for (let i = 0; i < valid.length; i++) {
      if (valid[i].IsDefault) {
        this.defaultTechnology = valid[i];
        this.defaultTechnologyId = valid[i]["@odata.id"];
        this.defaultTechnologyIngredients = _.orderBy(valid[i].Ingredients, 'LineOrd');
        // this.quantity =
        //   this.quantity * parseFloat(valid[i].ProduceQuantity.Value);
        this.fixQuantities();
        this.fixOrder();
        this.makeRecipeForRightMeasurementUnit();
        return true;
      }
    }

    this.defaultTechnology = moreResent;
    this.defaultTechnologyId = moreResent["@odata.id"];
    this.defaultTechnologyIngredients = _.orderBy(moreResent.Ingredients, 'LineOrd');
    this.fixQuantities();
    this.fixOrder();
    this.makeRecipeForRightMeasurementUnit();
    return true;
  }

  private fixQuantities() {
    // преизчислявам винаги рецептата за единица
    let productsQuantity = parseFloat(this.defaultTechnology.ProduceQuantity.Value);
    // console.log('fixQuantities', productsQuantity);
    if (productsQuantity == 1) {
      return true;
    }

    for (let i = 0; i < this.defaultTechnologyIngredients.length; i++) {
      let ingredient = this.defaultTechnologyIngredients[i];
      ingredient.UsageQuantity.Value = ingredient.UsageQuantity.Value / productsQuantity;
    }

    for (let i = 0; i < this.defaultTechnology.Operations.length; i++) {
      let operation = this.defaultTechnology.Operations[i];
      operation.UseQuantity.Value = operation.UseQuantity.Value / productsQuantity;
    }

    this.defaultTechnology.ProduceQuantity.Value = 1;
    // console.log('default', this);
  }

  private fixOrder() {
    this.defaultTechnology.Ingredients = _.orderBy(this.defaultTechnology.Ingredients, (i) => parseInt(i.LineOrd));
    this.defaultTechnology.Operations = _.orderBy(this.defaultTechnology.Operations, (i) => parseInt(i.LineOrd));
  }

  private makeRecipeForRightMeasurementUnit() {
    const measureInRecipe = _.get(this, 'measurementUnit.Code', 'a');
    const productBaseMeasure  = _.get(this, 'product.MeasurementUnit.Code', 'a');
    if(measureInRecipe === productBaseMeasure) {
      // в рецептата се използва продукт в базовата мерна единица
      return;
    }

    let coef = null;
    for(let i = 0; i <  this.product.Dimensions.length; i++) {
      const dimm = this.product.Dimensions[i];
      const destinationUnitCode = _.get(dimm, 'DestQuantityUnit.Code', null);
      const sourceUnitCode = _.get(dimm, 'SourceQuantityUnit.Code', null);
      const destinationQuantity = parseFloat(_.get(dimm, 'DestQuantity.Value'));
      const sourceQuantity = parseFloat(_.get(dimm, 'SourceQuantity.Value'));

      // console.log('destinationUnitCode', destinationUnitCode);
      // console.log('sourceUnitCode', sourceUnitCode);
      // console.log('destinationQuantity', destinationQuantity);
      // console.log('sourceQuantity', sourceQuantity);

      if(destinationUnitCode === measureInRecipe && sourceUnitCode === productBaseMeasure) {
        coef = (1/destinationQuantity)*sourceQuantity;
        break;
      }

      if(destinationUnitCode === productBaseMeasure && sourceUnitCode === measureInRecipe) {
        coef = (1/sourceQuantity)*destinationQuantity;
        break;
      }
    }

    for (let i = 0; i < this.defaultTechnologyIngredients.length; i++) {
      let ingredient = this.defaultTechnologyIngredients[i];
      ingredient.UsageQuantity.Value = ingredient.UsageQuantity.Value * coef;
    }

    for (let i = 0; i < this.defaultTechnology.Operations.length; i++) {
      let operation = this.defaultTechnology.Operations[i];
      operation.UseQuantity.Value = operation.UseQuantity.Value * coef;
    }
    // console.log(coef, this);
  }

  public getProductName() {
    return _.has(this.product, "Name.BG")
      ? this.product.Name.BG
      : _.has(this.product, "Name.EN")
        ? this.product.Name.EN
        : "";
  }

  public isStoreSet() {
    return _.get(this.product, 'CustomProperty_StoreForProdOrder.Value') != null;
  }

  public isSkiped() {
    //не е тествано и не се използва засега
    return this.skiped;
  }
}
